export default __webpack_public_path__ + "static/media/rocket_anim_47.e95449e6.png";